<template>
  <div class="text-center mt-2 text-body-2 text-primary">
    <button class="d-inline cursor-pointer" @click="toLogin">
      {{ $t('login') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import router from '@/router'

const toLogin = () => {
  router.replace('/login')
}
</script>
